import { Star } from '@mui/icons-material';
import { addStarRatingAPI, fetchStarRatingAPI, updateStarRatingAPI} from '../apis/index';


export const ADD_STAR_RATING_REQUEST = 'STAR_RATING_REQUEST';
export const ADD_STAR_RATING_SUCCESS = 'STAR_RATING_SUCCESS';
export const ADD_STAR_RATING_FAILURE = 'STAR_RATING_FAILURE';

export const UPDATE_STAR_RATING_REQUEST = 'UPDATE_STAR_RATING_REQUEST';
export const UPDATE_STAR_RATING_SUCCESS = 'UPDATE_STAR_RATING_SUCCESS';
export const UPDATE_STAR_RATING_FAILURE = 'UPDATE_STAR_RATING_FAILURE';

export const FETCH_STAR_RATING_REQUEST = 'FETCH_STAR_RATING_REQUEST';
export const FETCH_STAR_RATING_SUCCESS = 'FETCH_STAR_RATING_SUCCESS';
export const FETCH_STAR_RATING_FAILURE = 'FETCH_STAR_RATING_FAILURE';



// Action Creators for Star Rating
const addStarRatingRequest = () => ({
    type: ADD_STAR_RATING_REQUEST,
  });
  
  const addStarRatingSuccess = (rating) => ({
    type: ADD_STAR_RATING_SUCCESS,
    payload: rating,
  });
  
  const addStarRatingFailure = (error) => ({
    type: ADD_STAR_RATING_FAILURE,
    payload: error,
  });
  
  const updateStarRatingRequest = () => ({
    type: UPDATE_STAR_RATING_REQUEST,
  });
  
  const updateStarRatingSuccess = (rating) => ({
    type: UPDATE_STAR_RATING_SUCCESS,
    payload: rating,
  });
  
  const updateStarRatingFailure = (error) => ({
    type: UPDATE_STAR_RATING_FAILURE,
    payload: error,
  });
  
  const fetchStarRatingRequest = () => ({
    type: FETCH_STAR_RATING_REQUEST,
  });
  
  const fetchStarRatingSuccess = (chatId, rating) => ({
    type: FETCH_STAR_RATING_SUCCESS,
    payload: { chatId, ratingData: rating, status: rating.status },
  });
  
  const fetchStarRatingFailure = (error) => ({
    type: FETCH_STAR_RATING_FAILURE,
    payload: error,
  });
  
  // Thunks for Star Rating
  
  export const addStarRating = ({ chatId, rating, createdUTC, updatedAt, datasetId }) => {
    return async (dispatch) => {
      dispatch(addStarRatingRequest());
      try {
        const response = await addStarRatingAPI({ chatId, rating, createdUTC, updatedAt, datasetId }); // Call the API function
        dispatch(addStarRatingSuccess(response));
        return response;
        
      } catch (error) {
        console.error('Error adding star rating:', error.message);
        dispatch(addStarRatingFailure(error.message));
      }
    };
  };
  
  export const updateStarRating = ({ chatId, rating, createdUTC, updatedAt, datasetId, _id }) => {
    return async (dispatch) => {
      dispatch(updateStarRatingRequest());
      
      try {
        const response = await updateStarRatingAPI({ chatId, rating, createdUTC, updatedAt, datasetId, _id }); // Replace with actual API call
        dispatch(updateStarRatingSuccess(response));
      } catch (error) {
        dispatch(updateStarRatingFailure(error.message));
      }
    };
  };
  
  export const fetchStarRating = (chatId) => {
    return async (dispatch) => {
      dispatch(fetchStarRatingRequest());
      
      try {
        const response = await fetchStarRatingAPI(chatId);
        dispatch(fetchStarRatingSuccess(chatId, response));
        return response;
      } catch (error) {
        dispatch(fetchStarRatingFailure(error.message));
      }
    };
  };
  